import useSWR from "swr";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { StandardLight } from "./types";

export const useStandards = (query: PaginationQuery, signal: AbortSignal, isAdmin?: boolean) => {
  const api = useApi();
  const prefix = isAdmin ? "/admin" : "";
  const url = buildUrl(`${prefix}/modules/lock_calculator/selects/standards`, query);
  return useSWR<Paginated<StandardLight>, CustomError, string>(url, (requestUrl) =>
    api.get<Paginated<StandardLight>>({ url: requestUrl, signal }),
  );
};
